import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import * as commonVar from 'libs/commonVar';

import { Message, Label, Icon, Button, List } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import {
  ReduxFormHiddenRecord,
  ReduxFormMaterialTextField,
  ReduxFormMaterialSelect,
  ReduxFormSemanticDropdown,
  ReduxFormDatePicker,
  ModalLicense,
  Loading,
  Button as Btn
} from 'components';
import * as common from 'libs/commonFunc';

import moment from 'moment';

import classNames from 'classnames/bind';
import styles from './LicenseEdit.css';
const cx = classNames.bind(styles);

class LicenseEdit extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // 모달의 onOpen 이벤트 대용
    const { handleOnOpenEditModal } = this.props;

    handleOnOpenEditModal();
  }

  adjustEndDateOneYear = () => {
    if (this.datePickerEndDateRef && this.datePickerEndDateRef.props && this.datePickerEndDateRef.props.onChange) {
      const { formStore } = this.props;
      const storeStartDate = formStore.values ? formStore.values.startDate : null;

      if (storeStartDate) {
        this.datePickerEndDateRef.props.onChange(
          moment(storeStartDate)
            .hour(0)
            .minute(0)
            .second(0)
            .add(1, 'y')
            .subtract(1, 's')
        );
      }
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const {
      actionMode,
      isAuth,
      loginUser,
      formStore,
      onProgress,
      invalid,
      licenseInfo,
      saveLicense,
      serviceNoError,
      onInitError,
      handleOnToggleEditModal,
      timesLicenseError,
      durationLicenseError
    } = this.props;
    const { adjustEndDateOneYear } = this;

    const { startEpoch, endEpoch, licenseCount, licenseUnit } = licenseInfo;
    const { userName, userEmail, serviceName } = loginUser;

    const requestInfo = [];
    requestInfo.push(
      <List.Item key={requestInfo.length}>
        <div className={cx('info-title')}>
          {defineMessages(formatMessage({ id: 'LicenseEdit_1', defaultMessage: '서비스' }))}
        </div>
        {serviceName}
      </List.Item>
    );
    requestInfo.push(
      <List.Item key={requestInfo.length}>
        <div className={cx('info-title')}>
          {defineMessages(formatMessage({ id: 'LicenseEdit_3', defaultMessage: '신청인' }))}
        </div>
        {userName}
      </List.Item>
    );
    requestInfo.push(
      <List.Item key={requestInfo.length}>
        <div className={cx('info-title')}>
          {defineMessages(formatMessage({ id: 'LicenseEdit_4', defaultMessage: '이메일' }))}
        </div>
        {userEmail}
      </List.Item>
    );

    const storeStartDate = formStore.values ? formStore.values.startDate : null;
    const storeEndDate = formStore.values ? formStore.values.endDate : null;
    const storeLicenseCount = formStore.values ? formStore.values.licenseCount : 0;
    const storeLicenseType = formStore.values ? formStore.values.licenseType : 0;

    const todayMoment = moment()
      .hour(0)
      .minute(0)
      .second(0);

    const licenseList = [
      // {
      //   key: 1,
      //   value: 1,
      //   text: defineMessages(formatMessage({ id: 'LicenseEdit_24', defaultMessage: '영구 라이센스' }))
      // },
      {
        key: 2,
        value: 2,
        text: defineMessages(formatMessage({ id: 'LicenseEdit_25', defaultMessage: '기간 라이센스' }))
      },
      {
        key: 4,
        value: 4,
        text: defineMessages(formatMessage({ id: 'LicenseEdit_26', defaultMessage: '횟수 라이센스' }))
      }
    ];

    let licenseCountList = [
      { key: 10, value: 10, text: '10' },
      { key: 100, value: 100, text: '100' },
      { key: 300, value: 300, text: '300' },
      { key: 500, value: 500, text: '500' },
      { key: 700, value: 700, text: '700' },
      { key: 1000, value: 1000, text: '1000' },
      { key: 3000, value: 3000, text: '3000' },
      { key: 5000, value: 5000, text: '5000' },
      { key: 10000, value: 10000, text: '10000' }
    ];

    if (commonVar.isJapan !== 1) {
      licenseList.push({
        key: 4,
        value: 4,
        text: defineMessages(formatMessage({ id: 'LicenseEdit_26', defaultMessage: '횟수 라이센스' }))
      });
    } else {
      licenseCountList = [
        { key: 100, value: 100, text: '100' },
        { key: 200, value: 200, text: '200' },
        { key: 300, value: 300, text: '300' },
        { key: 400, value: 400, text: '400' },
        { key: 500, value: 500, text: '500' },
        { key: 700, value: 700, text: '700' },
        { key: 1000, value: 1000, text: '1000' }
      ];
    }

    return (
      <div className={cx('license-edit-box')}>
        <Loading
          active={onProgress}
          size="small"
          content={defineMessages(formatMessage({ id: 'LicenseEdit_5', defaultMessage: '정보를 불러오는 중...' }))}
        />
        {isAuth !== 2 && (
          <div>
            <div className={cx('message-header')}>
              {defineMessages(
                formatMessage({
                  id: 'LicenseEdit_6',
                  defaultMessage: '라이센스 발급에 따른 안내는 이메일을 통해 진행됩니다.'
                })
              )}
            </div>
            <Message negative={isAuth === 2} className={cx('license-edit-title template-detail-box')}>
              <List bulleted>{requestInfo}</List>
            </Message>
          </div>
        )}
        <div className={cx('license-edit-section')}>
          {isAuth === 2 && (
            <div>
              <span className={cx('materialTextField-title')}>
                {defineMessages(formatMessage({ id: 'LicenseEdit_7', defaultMessage: '서비스 No' }))}
              </span>
              <div className={cx('flex-row-center')}>
                <ReduxFormMaterialTextField
                  required
                  error={serviceNoError}
                  // helperText={!!errorMessage && errorMessage}
                  // label={defineMessages(formatMessage({ id: 'LicenseEdit_7', defaultMessage: '서비스 No' }))}
                  name="serviceNo"
                  className={cx('input-gap', 'flex-column', 'input-area')}
                  checkType={101}
                  validate={['required', 'number', 'maxNumber', 'space']}
                  onKeyPress={onInitError}
                  serviceCheck={serviceNoError
                    ? defineMessages(formatMessage({ id: 'LicenseEdit_50', defaultMessage: '잘못된 서비스 번호입니다.' }))
                    : ''}
                />
              </div>
            </div>
          )}
          {/* 라이센스 타입 */}
          <span className={cx('materialTextField-title')}>
            {defineMessages(formatMessage({ id: 'LicenseEdit_23', defaultMessage: '라이센스 타입' }))}
          </span>
          <div className={cx('flex-row-center', 'input-select')}>
            <ReduxFormMaterialSelect
              required
              // label={defineMessages(formatMessage({ id: 'LicenseEdit_23', defaultMessage: '라이센스 타입' }))}
              name="licenseType"
              className={cx('license-count', 'input-gap', 'flex-column', 'input-area')}
              menuList={licenseList}
              checkType={101}
              validate={['required']}
            />
          </div>
          {/* 횟수 라이센스의 횟수 설정 */}
          {storeLicenseType === 4 && (
            <div>
              <span className={cx('materialTextField-title')}>
                {defineMessages(formatMessage({ id: 'LicenseEdit_30', defaultMessage: '훈련 횟수' }))}
              </span>
              <div className={cx('flex-row-center', 'input-select')}>
                <ReduxFormMaterialSelect
                  required
                  // label={defineMessages(formatMessage({ id: 'LicenseEdit_30', defaultMessage: '훈련 횟수' }))}
                  name="examLimitCount"
                  className={cx('license-count', 'input-gap', 'flex-column', 'input-area')}
                  menuList={[
                    {
                      key: 1,
                      value: 1,
                      text: '1 ' + defineMessages(formatMessage({ id: 'LicenseEdit_31', defaultMessage: '회' }))
                    },
                    {
                      key: 2,
                      value: 2,
                      text: '2 ' + defineMessages(formatMessage({ id: 'LicenseEdit_31', defaultMessage: '회' }))
                    },
                    {
                      key: 3,
                      value: 3,
                      text: '3 ' + defineMessages(formatMessage({ id: 'LicenseEdit_31', defaultMessage: '회' }))
                    },
                    {
                      key: 4,
                      value: 4,
                      text: '4 ' + defineMessages(formatMessage({ id: 'LicenseEdit_31', defaultMessage: '회' }))
                    },
                    {
                      key: 5,
                      value: 5,
                      text: '5 ' + defineMessages(formatMessage({ id: 'LicenseEdit_31', defaultMessage: '회' }))
                    },
                    {
                      key: 10,
                      value: 10,
                      text: '10 ' + defineMessages(formatMessage({ id: 'LicenseEdit_31', defaultMessage: '회' }))
                    },
                    {
                      key: 20,
                      value: 20,
                      text: '20 ' + defineMessages(formatMessage({ id: 'LicenseEdit_31', defaultMessage: '회' }))
                    },
                    {
                      key: 30,
                      value: 30,
                      text: '30 ' + defineMessages(formatMessage({ id: 'LicenseEdit_31', defaultMessage: '회' }))
                    },
                    {
                      key: 40,
                      value: 40,
                      text: '40 ' + defineMessages(formatMessage({ id: 'LicenseEdit_31', defaultMessage: '회' }))
                    },
                    {
                      key: 50,
                      value: 50,
                      text: '50 ' + defineMessages(formatMessage({ id: 'LicenseEdit_31', defaultMessage: '회' }))
                    },
                    {
                      key: 100,
                      value: 100,
                      text: '100 ' + defineMessages(formatMessage({ id: 'LicenseEdit_31', defaultMessage: '회' }))
                    }
                  ]}
                  checkType={101}
                  validate={['required']}
                  error={timesLicenseError}
                  errorText={timesLicenseError
                    ? defineMessages(formatMessage({ id: 'LicenseEdit_49', defaultMessage: '훈련한 횟수 이상이어야 합니다.' }))
                    : ''}
                />
              </div>
            </div>
          )}
          {/* 시작일자 */}
          {storeLicenseType === 2 && (
            <div className={cx('date-wrapper')}>
              <span className={cx('materialTextField-title')}>
                {defineMessages(formatMessage({ id: 'LicenseEdit_8', defaultMessage: '유효기간 시작일자' }))}
              </span>
              <div className={cx('flex-row-center', 'display-block')}>
                <ReduxFormDatePicker
                  required
                  defaultValue={actionMode === 'edit' ? storeStartDate : todayMoment}
                  className={cx('date-input', 'input-gap', 'flex-column', 'input-area')}
                  name="startDate"
                  locale={localStorage.getItem('language')}
                  todayButton="Today"
                  shouldCloseOnSelect
                  showYearDropdown
                  dropdownMode="select"
                  showMonthDropdown
                  dateFormat={localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD'}
                  // minDate={todayMoment}
                  //maxDate={moment().add(20, 'years')}
                  maxDate={moment('2036-12-31')}
                  // inputLabel={defineMessages(formatMessage({ id: 'LicenseEdit_8', defaultMessage: '유효기간 시작일자' }))}
                  checkType={101}
                  validate={['dateRequired', 'reduxFormDatePicker']}
                  selectsStart
                  startDate={storeStartDate ? storeStartDate : todayMoment}
                  endDate={storeEndDate}
                  error={storeStartDate === null ? true : false}
                />
                {storeStartDate &&
                  isAuth !== 2 && (
                    <div className={cx('domain-info', 'expect-end-date')}>
                      {defineMessages(formatMessage({ id: 'LicenseEdit_9', defaultMessage: '로 부터 1년' })) +
                        ' (~' +
                        common.timeFormatFromUTCEpoch(
                          moment(storeStartDate)
                            .hour(0)
                            .minute(0)
                            .second(0)
                            .add(1, 'y')
                            .subtract(1, 's')
                            .unix(),
                          3
                        ) +
                        ')'}
                    </div>
                  )}
              </div>
            </div>
          )}
          {/* 종료 일자 */}
          {isAuth === 2 &&
            storeLicenseType === 2 && (
              <div className={cx('date-wrapper')}>
                <span className={cx('materialTextField-title')}>
                  {defineMessages(formatMessage({ id: 'LicenseEdit_10', defaultMessage: '유효기간 종료일자' }))}
                </span>
                <div className={cx('flex-row-center', 'display-block')}>
                  <ReduxFormDatePicker
                    required
                    defaultValue={
                      actionMode === 'edit'
                        ? storeEndDate
                        : storeStartDate
                          ? moment(storeStartDate).add(1, 'y')
                          : moment(todayMoment)
                            .add(1, 'y')
                            .subtract(1, 's')
                    }
                    className={cx('date-input', 'input-gap', 'flex-column', 'input-area')}
                    name="endDate"
                    locale={localStorage.getItem('language')}
                    todayButton="Today"
                    shouldCloseOnSelect //={false}
                    showYearDropdown
                    dropdownMode="select"
                    showMonthDropdown
                    dateFormat={localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD'}
                    // minDate={storeStartDate < todayMoment ? todayMoment : storeStartDate}
                    maxDate={moment('2037-12-31')}
                    // inputLabel={defineMessages(
                    //   formatMessage({ id: 'LicenseEdit_10', defaultMessage: '유효기간 종료일자' })
                    // )}
                    checkType={101}
                    validate={['dateRequired', 'reduxFormDatePicker']}
                    selectsEnd
                    startDate={storeStartDate}
                    endDate={storeEndDate}
                    refPass={ref => (this.datePickerEndDateRef = ref)}
                  />
                </div>
                <div className={cx('license-label-info')}>
                  {storeStartDate &&
                    storeEndDate && (
                      <div className={cx('expect-end-date', 'domain-info')}>
                        {defineMessages(formatMessage({ id: 'LicenseEdit_11', defaultMessage: '유효기간' }))}
                        {': ' +
                          Math.round(moment.duration(storeEndDate.diff(storeStartDate)).asDays()) +
                          defineMessages(formatMessage({ id: 'LicenseEdit_12', defaultMessage: '일' }))}
                      </div>
                    )}
                  <Label
                    basic
                    className={cx('year-fit-end-date')}
                    color="blue"
                    as="a"
                    size="small"
                    onClick={adjustEndDateOneYear}>
                    {defineMessages(formatMessage({ id: 'LicenseEdit_13', defaultMessage: '1년으로 종료일 맞춤' }))}
                  </Label>
                </div>
              </div>
            )}
          <span className={cx('materialTextField-title')}>
            {defineMessages(formatMessage({ id: 'LicenseEdit_15', defaultMessage: '라이센스 수량 (명)' }))}
          </span>
          <div className={cx('flex-row-center', 'input-select')}>
            {isAuth === 2 ? (
              <ReduxFormMaterialTextField
                required
                // label={'라이센스 수량 (명)'}
                name="licenseCount"
                className={cx('input-gap', 'flex-column', 'input-area')}
                checkType={101}
                validate={['required', 'number', 'licenseCountMax', 'licenseCountMin']}
                error={durationLicenseError}
                errorText={durationLicenseError
                  ? defineMessages(formatMessage({ id: 'LicenseEdit_48', defaultMessage: '사용한 라이센스 수량 이상이어야 합니다.' }))
                  : ''}
              />
            ) : (
                <ReduxFormMaterialSelect
                  required
                  // label={defineMessages(formatMessage({ id: 'LicenseEdit_15', defaultMessage: '라이센스 수량 (명)' }))}
                  name="licenseCount"
                  className={cx('license-count', 'input-gap', 'input-area', 'flex-column', 'last-input')}
                  menuList={licenseCountList}
                  checkType={101}
                  validate={['required']}
                />
              )}
            {/* {storeLicenseCount > 0 && (
              <div className={cx('expect-end-date')}>{'(' + common.commaNumber(storeLicenseCount * 1000) + '명)'}</div>
            )} */}
          </div>
          {isAuth === 2 && (
            <div className={cx('flex-row-flex-start', 'input-gap', 'input-select')}>
              <ReduxFormMaterialSelect
                required
                // label={defineMessages(formatMessage({ id: 'LicenseEdit_16', defaultMessage: '처리 단계' }))}
                name="approve"
                className={cx('list-target', 'input-flex', 'flex-column', 'input-area')}
                fullWidth
                menuList={[
                  {
                    key: 1,
                    value: 1,
                    text: defineMessages(formatMessage({ id: 'LicenseEdit_18', defaultMessage: '승인' }))
                  },
                  {
                    key: 0,
                    value: 0,
                    text: defineMessages(formatMessage({ id: 'LicenseEdit_19', defaultMessage: '신청' }))
                  }
                ]}
                defaultValue={1}
                checkType={101}
                validate={['required']}
              />
              <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
              <ReduxFormMaterialSelect
                required
                // label={defineMessages(formatMessage({ id: 'LicenseEdit_17', defaultMessage: '삭제 여부' }))}
                name="licenseEnabled"
                className={cx('list-target', 'input-flex', 'flex-column', 'input-area')}
                fullWidth
                menuList={[
                  {
                    key: 0,
                    value: 0,
                    text: defineMessages(formatMessage({ id: 'LicenseEdit_20', defaultMessage: '삭제' }))
                  },
                  {
                    key: 1,
                    value: 1,
                    text: defineMessages(formatMessage({ id: 'LicenseEdit_21', defaultMessage: '정상' }))
                  }
                ]}
                defaultValue={1}
                checkType={101}
                validate={['required']}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

LicenseEdit.propTypes = {
  //
  licenseInfo: PropTypes.object,
  formStore: PropTypes.object
};
LicenseEdit.defaultProps = {
  //
  licenseInfo: {},
  formStore: {}
};

export default injectIntl(LicenseEdit);



// WEBPACK FOOTER //
// ./src/script/components/license/LicenseEdit.js